import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { hot } from 'react-hot-loader'
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'

// Containers
import { DefaultLayout } from './containers';
import history from './store/createHistory'

// Pages
import { Login } from './views/Pages';

class App extends Component {
  render() {
    return (
      <Router history={ history }>
       <Switch>
          <Route exact path="/login" name="Login Page" component={ Login } />
          <Route path="/" name="Home" component={ DefaultLayout } />
        </Switch>
      </Router>
    );
  }
}
export default hot(module)(App)



// WEBPACK FOOTER //
// ./src/App.js